































































































































import { Component } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';

import CustomerImportService from '@/api/CustomerImportService';
import {
  ECustomerImportProgressStatus,
  ICustomerImportCampaign,
  ICustomerImportStatus
} from '@/models/customer-import';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import CustomerImportOverview from '@/componentsV2/templates/CustomerImportOverview/CustomerImportOverview.vue';
import CustomerImportList from '@/componentsV2/templates/CustomerImportList/CustomerImportList.vue';

import CustomerImportEmptyState, {
  EEmptyStateTabs
} from './CustomerImportEmptyState.vue';
import eventBus from '@/utils/eventBus';
import ModalOptions, { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { ECustomerImportSteps } from '@/componentsV2/templates/Modals/CustomerImportModal/CustomerImportModal.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import InfoIcon from '@/components/icons/Info.vue';
import CustomerImportBanner from '@/componentsV2/templates/CustomerImportBanner/CustomerImportBanner.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ArrowBanner from '@/components/icons/ArrowBanner.vue';
import segmentIo from '@/utils/segment.io';
import BannerActivateWidget from '@/components/molecules/BannerActivateWidget/BannerActivateWidget.vue';
import { widgetIsActive, widgetIsEnabled } from '@/router/validators/utils';
import flagKeys from '@/constants/flagKeys';
import { needProviderConnected } from '@/utils/provider';
import { needLaunchRewardsProgram } from '@/utils/start-guide';
import { getIsRewardActivated } from '@/utils/rewards';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    PoseTransition,
    Shade: posed.div({
      enter: {
        opacity: 1,
        transition: { duration: 300 }
      },
      exit: { opacity: 0 }
    }),
    Page,
    CustomerImportOverview,
    CustomerImportList,
    CustomerImportEmptyState,
    Checkbox,
    InfoIcon,
    CustomerImportBanner,
    FilledButton,
    ArrowBanner,
    BannerActivateWidget
  }
})
export default class CustomerImport extends BillingModel {
  customerImportService = new CustomerImportService();

  createCampaignLoading = false;
  loading = false;
  loadingReload = false;
  customerImportStatus: ICustomerImportStatus = {} as ICustomerImportStatus;
  campaign: ICustomerImportCampaign = {} as ICustomerImportCampaign;
  emptyStateTab = 0;
  eligibleCustomerAmount = 0;

  allowShowBanner = true;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get customerImportV2() {
    return this.flags.includes('customer-import-v2');
  }

  get needRewardsProgramEmptyState() {
    return needLaunchRewardsProgram(true);
  }

  get rewardsActive() {
    return getIsRewardActivated();
  }

  get hideBanner() {
    return (
      (this.loading && !this.loadingReload) ||
      !this.shouldShowCampaignData ||
      this.campaign.automaticInvites ||
      this.eligibleCustomerAmount < 1 ||
      !this.allowShowBanner
    );
  }

  get pageDescription() {
    if (!this.shouldShowCampaignData) return '';

    return `Customers will receive a professional email from Twism, on your behalf, to get new members to join your Loyalty Rewards Program.`;
  }

  get needProviderEmptyState() {
    return needProviderConnected(this.$route as any) && this.emptyCampaign;
  }

  get shouldShowCampaignData() {
    return (
      !!this.customerImportStatus.clickedGetStarted &&
      this.customerImportStatus.status === ECustomerImportProgressStatus.DONE
    );
  }

  get customersBanner() {
    return this.eligibleCustomerAmount;
  }

  get emptyCampaign() {
    return !this.campaign.createdAt;
  }

  get multipleNewCustomers() {
    return this.eligibleCustomerAmount > 1;
  }

  get widgetDeactivated() {
    return (
      !widgetIsEnabled() &&
      this.flags.includes(flagKeys.widgetDeactivationAlerts) &&
      widgetIsActive()
    );
  }

  get tPrefix() {
    return 'customerImport.overview';
  }

  get status() {
    return this.campaign.automaticInvites;
  }

  get descriptionBanner() {
    return this.$t(
      `${this.tPrefix}.banner.description${
        this.emptyCampaign ? 'Create' : 'Enable'
      }${this.multipleNewCustomers ? 'Multiple' : 'Single'}`
    );
  }

  openCampaignActivationModal(onConfirm?: Function) {
    segmentIo.modal(
      `Invite Customers/${this.status ? 'Disable' : 'Enable'} Email Campaign`
    );

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        `${this.status ? 'disable' : 'enable'}Campaign`,
        false,
        true,
        true,
        true,
        true
      ),
      {
        total: this.eligibleCustomerAmount,
        onConfirm: async () => {
          if (!this.campaign.id) return;

          this.customerImportService.setCampaign({
            payload: {
              flag: 'automaticInvites',
              value: !this.status
            },
            campaignId: this.campaign.id
          });
          this.campaign.automaticInvites = !this.status;
          if (onConfirm) onConfirm();
        }
      }
    );
  }

  triggerActivation() {
    if (this.widgetDeactivated && !this.status) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `activateFeatureWidgetModal`,
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        }),
        {
          needActivation: true,
          onConfirm: () =>
            this.openCampaignActivationModal(() => {
              eventBus.$emit(
                'openSubModal',
                new ModalOptionsV2({
                  componentToRender: `successModal`,
                  hideCancelButton: false,
                  icon: '',
                  mobilePositionBottom: true,
                  mobileFullScreen: false
                }),
                {
                  title: 'Your widget and email campaign have been activated!',
                  btnText: 'Done'
                }
              );
            })
        }
      );
      return;
    }
    this.openCampaignActivationModal();
  }

  async handleOpenCustomerImportModal() {
    this.createCampaignLoading = true;
    try {
      this.$analytics({
        eventCategory: `Import Customers | Campaign Detail Page`,
        eventAction: 'click',
        eventLabel: `Clicked on the "Create campaign" button`
      });
      await this.openCampaignCreationModal();
    } finally {
      this.createCampaignLoading = false;
    }
  }

  async openCampaignCreationModal() {
    try {
      this.$showLoaderWithLocker();

      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'customerImportModal',
          false,
          true,
          true,
          true,
          false,
          false,
          false,
          true
        ),
        {
          defaultStep: ECustomerImportSteps.OFFER_CREATION,
          disableStatusPolling: true,
          customerImportFormData: {
            numberOfCustomers: data.total
          }
        }
      );
    } finally {
      this.$hideLoader();
    }
  }

  handleImportFinished(customerImportStatus: ICustomerImportStatus) {
    if (!customerImportStatus) return;
    this.allowShowBanner = false;

    this.customerImportStatus = customerImportStatus;

    this.openCampaignCreationModal();
  }

  async checkCustomerImportStatus(reload?: boolean) {
    try {
      if (!this.currentProvider) return;
      this.$showLoaderWithLocker();
      if (reload) {
        this.allowShowBanner = true;
        this.loadingReload = true;
      }
      this.loading = true;
      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      const { status, clickedGetStarted = false } = data;

      this.customerImportStatus = data;

      const eventMapper: Record<string, () => void> = {
        [ECustomerImportProgressStatus.IMPORTING]: () => {
          this.emptyStateTab = EEmptyStateTabs.PROGRESS;
        },
        [ECustomerImportProgressStatus.QUEUED]: () => {
          this.emptyStateTab = EEmptyStateTabs.PROGRESS;
        },
        [ECustomerImportProgressStatus.PENDING]: () => {
          this.emptyStateTab = EEmptyStateTabs.PROGRESS;
        }
      };

      if (clickedGetStarted && eventMapper[status]) {
        eventMapper[status]();
      }

      const campaigns = await this.customerImportService.getCampaigns();

      const elegibleCustomers = await this.customerImportService.getElegibleCustomers(
        this.currentProvider.name
      );

      if (elegibleCustomers.status === 200) {
        this.eligibleCustomerAmount =
          elegibleCustomers.data.eligibleCustomerAmount;
      }

      if (campaigns.data.items.length) {
        this.campaign = {
          ...campaigns.data.items[0],
          totalCustomers: data.total
        };
      }
    } finally {
      this.$hideLoader();
      if (reload) this.loadingReload = false;
      this.loading = false;
    }
  }

  mounted() {
    this.checkCustomerImportStatus();
    eventBus.$on('reloadCustomerImport', () =>
      this.checkCustomerImportStatus(true)
    );
  }

  beforeDestroy() {
    eventBus.$off('reloadCustomerImport', () =>
      this.checkCustomerImportStatus(true)
    );
  }
}
